import React from "react";

const AboutCards = ({ title, description }) => {
  return (
    <div className="relative flex flex-col w-full md:w-full h-[400px] rounded-lg bg-[#F2F2F2] shadow-md hover:shadow-lg items-center justify-center group">
      <h1 className="text-[25px] text-[#002F6C]">{title}</h1>
      <div className="absolute flex w-full h-full p-6 bg-[#F2F2F2]/60 rounded-lg opacity-0 group-hover:opacity-100 transition-all ease-in-out duration-500 backdrop-blur-md items-center justify-center">
        <p className="accent-text text-center">{description}</p>
      </div>
    </div>
  );
};

export default AboutCards;
